var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.options.length)?_c('q-expansion-item',{staticClass:"text-left",attrs:{"expand-separator":"","icon":"checklist","label":"Field Options","default-opened":_vm.open}},_vm._l((_vm.options),function(option){return _c('inherited-data-field-option',{key:option.id,attrs:{"option":option,"disable":_vm.disable}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }